import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  AdminSidebarData,
 
  ManagerSidebarData,
  Hotel_Admin_SidebarData,
  ReceponistSidebarData,
  SpaSidebarData,
  restoSidebarData,SubAdminSidebarData
} from "./SidebarData";
//Simple bar
import SimpleBar from "simplebar-react";
// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { Link } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
const Sidebar = (props) => {
  const ref = useRef();

  const logUser = JSON.parse(localStorage.getItem("user"));
  // const ref = useRef();
  // console.log(logUser,"a")

   const getSidebarDataByRole = () => {
  switch (logUser.role || logUser.role) {
    case "ADMIN":
      return AdminSidebarData;
    case "SUBADMIN":
      return SubAdminSidebarData;
    case "HOTEL_ADMIN":
      return Hotel_Admin_SidebarData;
    case "RECEPTIONIST":
      return ReceponistSidebarData;
    case "SPA":
      return SpaSidebarData;
    case "FOOD AND BEVERAGE":
      return restoSidebarData;
    case "SUPERVISOR":          // ✅ ADD THIS
      return restoSidebarData;  // ✅ Same sidebar as restaurant
    case "MANAGER":
      return ReceponistSidebarData;
    default:
      return [];
  }
};

  const sidebarData = getSidebarDataByRole();

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag
        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);
  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };
  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu-item");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);
  useEffect(() => {
    ref.current.recalculate();
  }, []);
  useEffect(() => {
    new MetisMenu("#side-menu-item");
    activeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Ensure sidebar is fully open on mobile by default and close on outside click
  useEffect(() => {
    const isMobile = window.innerWidth <= 992;
    if (isMobile) {
      document.body.classList.add("sidebar-enable");
      document.body.classList.remove("vertical-collpsed");
    }

    const handleOutsideClick = (event) => {
      if (!isMobile) return;
      const sidebarEl = document.querySelector(".vertical-menu");
      if (sidebarEl && !sidebarEl.contains(event.target)) {
        document.body.classList.remove("sidebar-enable");
      }
    };

    document.addEventListener("click", handleOutsideClick, true);
    return () => {
      document.removeEventListener("click", handleOutsideClick, true);
    };
  }, []);
  useEffect(() => {
    activeMenu();
  }, [activeMenu]);
  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }
  // Close sidebar on navigation for small screens for better UX
  useEffect(() => {
    const unlisten = props.router.navigate?.listen?.(() => {
      if (window.innerWidth <= 998) {
        document.body.classList.remove("sidebar-enable");
      }
    });
    return () => {
      if (unlisten && typeof unlisten === "function") unlisten();
    };
  }, [props.router.navigate]);

  return (
    <React.Fragment>
      <div className="vertical-menu" style={{position:'fixed'}}>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {(sidebarData || []).map((item, key) => (
                <React.Fragment key={key}>
                  {item.isMainMenu ? (
                    <li className="menu-title">{props.t(item.label)}</li>
                  ) : (
                    <li key={key}>
                      <Link
                        to={item.url ? item.url : "/#"}
                        className={
                          item.issubMenubadge || item.isHasArrow
                            ? " "
                            : "has-arrow"
                        }
                        onClick={() => {
                          if (!item.subItem && window.innerWidth <= 998) {
                            document.body.classList.remove("sidebar-enable");
                          }
                        }}
                        aria-label={props.t(item.label)}
                      >
                        <i
                          className={item.icon}
                          style={{ marginRight: "5px" }}
                        ></i>
                        {item.issubMenubadge && (
                          <span
                            className={
                              "badge rounded-pill float-end " + item.bgcolor
                            }
                          >
                            {" "}
                            {item.badgeValue}{" "}
                          </span>
                        )}
                        <span>{props.t(item.label)}</span>
                      </Link>
                      {item.subItem && (
                        <ul className="sub-menu">
                          {item.subItem.map((item, key) => (
                            <li key={key}>
                              <Link
                                to={item.link}
                                className={
                                  item.subMenu && "has-arrow waves-effect"
                                }
                                onClick={() => {
                                  if (window.innerWidth <= 998) {
                                    document.body.classList.remove("sidebar-enable");
                                  }
                                }}
                                aria-label={props.t(item.sublabel)}
                              >
                                {props.t(item.sublabel)}
                              </Link>
                              {item.subMenu && (
                                <ul className="sub-menu">
                                  {item.subMenu.map((item, key) => (
                                    <li key={key}>
                                      <Link to="#" aria-label={props.t(item.title)}>{props.t(item.title)}</Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  );
};
Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Sidebar));

